module["exports"] = [
  "Dr.",
  "Prof. Dr."
];
